import TopMenu from './menus/TopMenu';
import SiteLogo from './images/SiteLogo';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import WritingPage from './pages/WritingPage';
import TechPage from './pages/TechPage';
import DesignPage from './pages/DesignPage';
import PressPage from './pages/PressPage';
import ContactPage from './pages/ContactPage';

function App() {

  const [navlcl, setNavlcl] = useState('/');
  
  const linkto = (dest) => {
    //console.log("linkto", dest);
    setNavlcl(dest);
  }

  return (
    <div className="App">
      <BrowserRouter>
        <SiteLogo />
        <TopMenu location={navlcl} navmethod={linkto} />
        <Routes>
          <Route path="/" element={<div className='bighi'>hello</div>} />
          <Route path="/writing/:id?" element={<WritingPage />} />
          <Route path="/tech/:id?" element={<TechPage />} />
          <Route path="/design/:id?" element={<DesignPage />} />
          <Route path="/press/:id?" element={<PressPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
       </BrowserRouter> 
    </div>
  );
}

export default App;
